import { apiSlice } from "./apiSlice";
import {
  setTransactionReasons,
  setTransactionReasonsSelection,
  setTransactions,
} from "../slice/reportSlice";

export const reportApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createTransactionReason: builder.mutation({
      query: data => ({ url: "/api_report/transaction_reason/", method: "post", body: data }),
    }),

    getTransactions: builder.query({
      query: (params = null) =>
        params ? `/api_report/transactions/?${params}` : "/api_report/transactions/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setTransactions(result.data))).catch(error => {});
      },
    }),
    getTransactionReasons: builder.query({
      query: (params = null) =>
        params ? `/api_report/transaction_reason/?${params}` : "/api_report/transaction_reason/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setTransactionReasons(result.data)))
          .catch(error => {});
      },
    }),

    getTransactionReasonById: builder.query({
      query: id => ({
        url: `/api_report/transaction_reason/${id}/`,
      }),
    }),

    getTransactionReasonsSelection: builder.query({
      query: ({ params = null }) => ({ url: `/api_report/transaction_reason/selection/`, params }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setTransactionReasonsSelection(result.data)))
          .catch(error => {});
      },
    }),
    updateTransactionReason: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api_report/transaction_reason/${id}/`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useCreateTransactionReasonMutation,
  useGetTransactionsQuery,
  useGetTransactionReasonsQuery,
  useGetTransactionReasonByIdQuery,
  useGetTransactionReasonsSelectionQuery,
  useLazyGetTransactionReasonsSelectionQuery,
  useUpdateTransactionReasonMutation,
} = reportApiSlice;
